var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-4" },
    [
      !_vm.mobile
        ? _c("div", { staticClass: "text-center mb-3" }, [
            _c("img", {
              staticClass: "svg-icon-avatar",
              attrs: { src: _vm.svgPath, width: "150", height: "150" }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "", row: "" } },
        [
          _c(
            "v-flex",
            {
              staticClass: "summary-icons-flex",
              attrs: { xs6: "", sm6: "", md3: "" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "my-cover-carousel-border d-flex flex-column justify-center align-center fill-height",
                  class: _vm.mobile ? "pa-0" : "mb-3 px-1 py-3"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        "x-large": !_vm.isMobile,
                        color: _vm.$vuetify.theme.dark ? "" : "primary"
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            parseInt(_vm.client.gender) !== 1
                              ? "$mdiLegacyFemale"
                              : "$mdiLegacyMale"
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h4",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            parseInt(_vm.client.gender) !== 1
                              ? "Female"
                              : "Male"
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "summary-icons-flex",
              attrs: { xs6: "", sm6: "", md3: "" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "my-cover-carousel-border d-flex flex-column justify-center align-center fill-height",
                  class: _vm.mobile ? "pa-0" : "mb-3 px-1 py-3"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        "x-large": !_vm.isMobile,
                        color: _vm.$vuetify.theme.dark ? "" : "primary"
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            parseInt(_vm.client.smoker) !== 1
                              ? "$mdiLegacySmoking"
                              : "$mdiLegacySmokingOff"
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h4",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            parseInt(_vm.client.smoker) !== 1
                              ? "Smoker"
                              : "Non-smoker"
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "summary-icons-flex",
              attrs: { xs6: "", sm6: "", md3: "" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "my-cover-carousel-border d-flex flex-column justify-center align-center fill-height",
                  class: _vm.mobile ? "pa-0" : "mb-3 px-1 py-3"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        "x-large": !_vm.isMobile,
                        color: _vm.$vuetify.theme.dark ? "" : "primary"
                      }
                    },
                    [
                      _vm._v(
                        "\n                    $mdiLegacyANB\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h4",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [
                      _vm._v(
                        "\n                    ANB: " +
                          _vm._s(parseInt(_vm.client.age) + 1) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "summary-icons-flex",
              attrs: { xs6: "", sm6: "", md3: "" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "my-cover-carousel-border d-flex flex-column justify-center align-center fill-height",
                  class: _vm.mobile ? "pa-0" : "mb-3 px-1 py-3"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        "x-large": !_vm.isMobile,
                        color: _vm.$vuetify.theme.dark ? "" : "primary"
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s("$mdiLegacyCat" + _vm.client_rating) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h4",
                    {
                      class: _vm.$vuetify.theme.dark
                        ? "white--text"
                        : "primary--text"
                    },
                    [_vm._v("\n                    Category\n                ")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }